// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"834af9d5","120":"558fbf0f","181":"95d902c1","333":"f594dfd1","799":"13a4b41a","830":"bf92cd52","945":"a52b42d7"}[chunkId] + ".chunk.css";
};